module.exports = __webpack_public_path__ + "static/media/natural-stone-black.22b9c693.svg";